<script setup lang="ts">
import type { PropType } from 'vue'
import type { ICustomSliderBox } from '~/layers/homepage/data/types'
import type { NavigationOptions } from 'swiper/types'

const props = defineProps({
  section: {
    type: Object as PropType<ICustomSliderBox>,
    required: true,
  },
})
const { section } = toRefs(props)

const isOpened = ref(false)
const clickHandler = () => {
  if (section.value.items.length === 0 || !window.matchMedia('(min-width: 1024px)').matches ) {
    useRouter().push(section.value.link)
    return
  }
  isOpened.value = !isOpened.value
}

const prevEl = ref(null)
const nextEl = ref(null)
const navigation: NavigationOptions = {
  nextEl: prevEl.value,
  prevEl: nextEl.value,
}
</script>

<template>
  <div class="fixed-panel fixed-panel_txt-mobile" @click="clickHandler">
    <div class="fixed-panel__body">
      <div class="fixed-panel__actions">
        <slot name="navigation"></slot>
        <slot name="scrollbar"></slot>
      </div>
      <p class="fixed-panel__title">{{ section.title }}</p>
      <p class="fixed-panel__subtitle">{{ section.name }}</p>
    </div>
  </div>
  <div
    v-if="section.items.length > 0"
    class="fixed-panel__menu"
    :class="{ 'fixed-panel__menu_open': isOpened }"
  >
    <div class="slider slider-collections mix-blend-multiply">
      <client-only>
        <swiper-container
          :navigation="navigation"
          :speed="800"
          class="swiper-container slider__collections"
          init
          slides-per-view="auto"
          watch-overflow
        >
          <swiper-slide class="slider-collections__good" v-for="item in section.items" :key="item.name">
            <nuxt-link :to="item.link" class="slider-collections__good-img">
              <URemotePicture :picture="item.picture" />
            </nuxt-link>
            <nuxt-link class="slider-collections__good-link" :to="item.link">{{ item.name }}</nuxt-link>
          </swiper-slide>
        </swiper-container>
      </client-only>
      <div v-if="section.items.length > 3" class="slider__navigation">
        <button class="slider__button slider__button_prev" type="button" ref="prevEl">
          <svg-icon height="20" name="left-slider" width="20" />
        </button>
        <button class="slider__button slider__button_next" type="button" ref="nextEl">
          <svg-icon height="20" name="right-slider" width="20" />
        </button>
      </div>
    </div>
  </div>
</template>
